import { Camera, MapPin, Clock } from "lucide-react";
import { Badge, SHOOTING_STATUS_META, fmtD, fmtDur, TODAY } from "./shared";

/* Vue « Shootings » : planning centralisé de toutes les séances, par client */
export function ShootingsView({ shootings, clientName, onOpen }) {
  const upcoming = shootings.filter((s) => s.status !== "annule" && s.date >= TODAY);
  const past = shootings.filter((s) => s.status === "annule" || s.date < TODAY);
  const Card = ({ s, dim }) => (
    <button key={s.id} onClick={() => onOpen(s)} data-testid={`shooting-card-${s.id}`}
      className={`w-full text-left bg-white border border-[#E2E8F0] rounded-xl p-4 hover:border-[#93C5FD] hover:shadow-sm transition-all ${dim ? "opacity-60" : ""}`}>
      <div className="flex items-center justify-between gap-2">
        <p className="font-heading font-bold text-sm flex items-center gap-1.5">
          <Camera className="w-3.5 h-3.5 text-blue-600" /> {clientName[s.client_id] || "Client"}
        </p>
        <Badge meta={SHOOTING_STATUS_META} value={s.status || "planifie"} />
      </div>
      <p className="text-xs text-neutral-600 mt-1 flex items-center gap-2 flex-wrap">
        <span className="font-semibold">{fmtD(s.date)}{s.time ? ` à ${s.time}` : ""}</span>
        {s.duration_min ? <span className="flex items-center gap-0.5 text-neutral-400"><Clock className="w-3 h-3" /> {fmtDur(s.duration_min)}</span> : null}
        {s.location ? <span className="flex items-center gap-0.5 text-neutral-400"><MapPin className="w-3 h-3" /> {s.location}</span> : null}
      </p>
      {(s.events || []).length > 0 && (
        <div className="flex flex-wrap gap-1 mt-2">
          {s.events.map((e) => (
            <span key={e} className="text-[9px] font-medium border rounded-full px-2 py-0.5 bg-violet-50 text-violet-600 border-violet-200">{e}</span>
          ))}
        </div>
      )}
      <p className="text-[10px] text-neutral-400 mt-2" data-testid={`shooting-count-${s.id}`}>
        {s.done_count}/{(s.items || []).length} tournés{s.capacity ? ` · capacité ${(s.items || []).length}/${s.capacity}` : ""}
        {s.origin === "client" ? " · réservé par le client" : ""}
      </p>
    </button>
  );
  return (
    <div className="space-y-4" data-testid="shootings-view">
      <div>
        <p className="text-xs font-bold text-neutral-600 mb-2">Shootings à venir ({upcoming.length})</p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {upcoming.map((s) => <Card key={s.id} s={s} />)}
          {upcoming.length === 0 && <p className="text-xs text-neutral-300 py-4" data-testid="shootings-empty">Aucun shooting planifié — créez-en un depuis un événement ou le bouton « Shooting ».</p>}
        </div>
      </div>
      {past.length > 0 && (
        <div>
          <p className="text-xs font-bold text-neutral-400 mb-2">Passés / annulés ({past.length})</p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {past.map((s) => <Card key={s.id} s={s} dim />)}
          </div>
        </div>
      )}
    </div>
  );
}
